import React from "react";

export default function AdminTabScroller({ tabs, activeId, onChange, testId }) {
  return (
    <div className="relative mb-6" data-testid={testId}>
      <div className="flex gap-0 overflow-x-auto overscroll-x-contain border-b border-white/10 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => onChange(tab.id)}
            data-testid={tab.testId || `tab-${tab.id}`}
            className={`shrink-0 px-4 py-3 min-h-11 text-sm font-['Manrope'] font-medium border-b-2 whitespace-nowrap transition-colors ${
              activeId === tab.id
                ? "text-blue-400 border-blue-400"
                : "text-white/40 border-transparent hover:text-white/60"
            }`}
          >
            {tab.label}
            {tab.count != null && (
              <span className="ml-1.5 text-[11px] text-white/40">{tab.count}</span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
